var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-draggable-resize-combo",
    {
      staticClass: "container",
      attrs: {
        x: _vm.block.X,
        y: _vm.block.Y,
        width: _vm.block.Width,
        height: _vm.block.Height,
      },
      on: {
        "update:x": function ($event) {
          return _vm.$set(_vm.block, "X", $event)
        },
        "update:y": function ($event) {
          return _vm.$set(_vm.block, "Y", $event)
        },
        "update:width": function ($event) {
          return _vm.$set(_vm.block, "Width", $event)
        },
        "update:height": function ($event) {
          return _vm.$set(_vm.block, "Height", $event)
        },
      },
    },
    _vm._l(_vm.block.Lines, function (line, i) {
      return _c("div", { key: i, style: line.Style.getStyle() }, [
        _c("span", { style: line.PreTextStyle.getStyle() }, [
          _vm._v(_vm._s(line.PreText)),
        ]),
        _c("span", { style: line.PropStyle.getStyle() }, [
          _vm._v(_vm._s(line.getPropName(_vm.model))),
        ]),
        _c("span", { style: line.PostTextStyle.getStyle() }, [
          _vm._v(_vm._s(line.PostText)),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }